import { type ReactNode, useState } from 'react'
import type { KYCProvider } from '@funkit/connect-core'
import { FiatKycIntroScreen } from './FiatKycIntroScreen'

/** Mount the provider only after its introduction has been acknowledged. */
export function FiatDocumentCaptureStep({
  children,
  kycProvider,
  onBack,
}: {
  children: () => ReactNode
  kycProvider?: KYCProvider
  onBack: () => void
}) {
  const [started, setStarted] = useState(false)
  if (started) {
    return children()
  }
  return (
    <FiatKycIntroScreen
      documentVerification
      kycProvider={kycProvider}
      onContinue={() => setStarted(true)}
      onCancel={onBack}
    />
  )
}
